import { useTable } from "react-table";
import { useTranslation } from "react-i18next";

export default function Table({ columns, data }) {
  // Use the useTable Hook to send the columns and data to build the table
  const [t] = useTranslation("global");
  
  const {
    getTableProps, // table props from react-table
    getTableBodyProps, // table body props from react-table
    headerGroups, // headerGroups, if your table has groupings
    rows, // rows for the table based on the data passed
    prepareRow // Prepare the row (this function needs to be called for each row before getting the row props)
  } = useTable({
    columns,
    data
  });
  
  if (data.length === 0) {
	  return (
	  <table className="tabla" {...getTableProps()}>
      <thead className="cabeceraTabla">
        {	
		  // Recorremos las columnas que previamente definimos
		  headerGroups.map(headerGroup => (
		  // Añadimos las propiedades al conjunto de columnas
          <tr {...headerGroup.getHeaderGroupProps()}>
            {	
				// Recorremos cada columna del conjunto para acceder a su información
				headerGroup.headers.map(column => (			  
			  // Añadimos las propiedades a cada celda de la cabecera
              <th className="tablaHead" {...column.getHeaderProps()}>{				  
				  	// Pintamos el título de nuestra columna (propiedad "Header")
				  	column.render("Header")
				  }
			  </th>
            ))}
          </tr>
        ))}
      </thead>
      
      { /* Añadimos las propiedades al cuerpo de la tabla */}
      <tbody {...getTableBodyProps()}>
        <tr className="rowContent">
          {}
          <td className="colContent" colSpan={headerGroups[0].headers.length}>
            <p className="mensajeSinRegistros">{t("app.mensaje.sinRegistros")}</p>
          </td>
        </tr>
      </tbody>
    </table>
    );
  }

  /* 
    Render the UI for your table
    - react-table doesn't have UI, it's headless. We just need to put the react-table props from the Hooks, and it will do its magic automatically
  */
  return (
    <table className="tabla" {...getTableProps()}>
      <thead className="cabeceraTabla">
        {	
		  // Recorremos las columnas que previamente definimos
		  headerGroups.map(headerGroup => (
		  // Añadimos las propiedades al conjunto de columnas
          <tr {...headerGroup.getHeaderGroupProps()}>
            {	
				// Recorremos cada columna del conjunto para acceder a su información
				headerGroup.headers.map(column => (			  
			  // Añadimos las propiedades a cada celda de la cabecera
              <th className="tablaHead" {...column.getHeaderProps()}>{				  
				  	// Pintamos el título de nuestra columna (propiedad "Header")
				  	column.render("Header")
				  }
			  </th>
            ))}
          </tr>
        ))}
      </thead>
      
      { /* Añadimos las propiedades al cuerpo de la tabla */}
      <tbody {...getTableBodyProps()}>
        {
		  // Recorremos las filas
		  rows.map((row, i) => {
			  
		   // Llamamos a la función que prepara la fila previo renderizado
           prepareRow(row);
           return (
			  
			// Añadimos las propiedades a la fila
            <tr className="rowContent" {...row.getRowProps()}>
              {
				// Recorremos cada celda de la fila
				row.cells.map(cell => {
					
				// Añadimos las propiedades a cada celda de la fila
                return <td className="colContent" {...cell.getCellProps()}>{cell.render("Cell")}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}